import {
  saleDate,
  saleDayOfMonth,
  saleEndDate,
  saleEndDay,
  saleTime,
  saleWeekday,
  saleYear,
  tinySaleDate,
} from "./seasonalSale"

// The copy for the /black-friday page, from the Black Friday 2026 landing
// page doc. Only the sites below have the page; each has its own title, meta
// description, intro and body copy so no two pages read the same, and the
// rest of the page (top bar, hero, price box, FAQ) is shared, with the brand
// swapped in. Keyed by host like utils/sitePageSeo.js.

// The offer, the same on every site. bar swaps the sale price points in on
// the join page while the sale runs; these are what the page says about them.
// "Up to" because $9.95 against $29.95 is 67%: the sale's biggest saving is
// 70%, as the sale art says.
export const BLACK_FRIDAY_OFFER = {
  discount: "up to 70%",
  salePrice: "$9.95",
  regularPrice: "$29.95",
  billingLine:
    "Billed $9.95 every 30 days. Your price stays the same for as long as you're a member.",
}

// Each site's settings and words. `accent` is the brand color from its
// logo text (useSiteSettings' siteNameToColoredText), nudged where two sites
// shared one. `videos` and `format` fill the meta description; `format` also
// labels the feature strip. `intro` and `body` are the sale-live copy; `n` is
// the scene count, `price` the sale price, `ends` the day the sale ends
// ("Cyber Monday").
export const BLACK_FRIDAY_SITES = {
  "passion-hd.com": {
    brand: "Passion-HD",
    slug: "passion-hd",
    accent: "#f56ed5",
    videos: "sensual hardcore",
    format: "Full HD 1080p",
    intro: ({ discount, price, ends }) =>
      `Our biggest sale of the year is here. This Black Friday, get ${discount} off a Passion-HD membership and unlock every scene in our library for just ${price}. The sale ends ${ends}, and then the price goes back up.`,
    body: ({ n }) => [
      {
        lead: "Sex with real chemistry.",
        text: `Passion-HD is about sensual, intimate scenes between performers who actually enjoy each other. Slow build-ups, real connection and beautiful production in Full HD 1080p. Your membership unlocks all ${n}+ scenes, plus every new release while you're a member.`,
      },
      {
        lead: "Why now.",
        text: "This is the lowest price we offer all year, and it only comes around once. If you've been waiting for the right time to join, this is it.",
      },
    ],
  },
  "anal4k.com": {
    brand: "Anal4K",
    slug: "anal4k",
    accent: "#db2777",
    videos: "anal",
    format: "HD 4K",
    intro: ({ discount, price, ends }) =>
      `Black Friday is the one time a year we cut the price this far. Get ${discount} off an Anal4K membership and watch every scene in crisp 4K for just ${price}. The deal ends ${ends}.`,
    body: ({ n }) => [
      {
        lead: "Anal, shot properly.",
        text: `Anal4K is dedicated to one thing and does it in true 4K: ${n}+ full-length anal scenes with the hottest performers in the business, filmed so you see every detail.`,
      },
      {
        lead: "Everything included.",
        text: "Your membership unlocks the full library and every new update. Stream on any device, cancel anytime.",
      },
    ],
  },
  "bbcpie.com": {
    brand: "BBC Pie",
    slug: "bbcpie",
    accent: "#c70200",
    videos: "interracial creampie",
    format: "4K",
    intro: ({ discount, price, ends }) =>
      `The BBC Pie Black Friday sale is live. Take ${discount} off your membership and get the whole library for just ${price}, our best price of the year. It's gone after ${ends}.`,
    body: ({ n }) => [
      {
        lead: "What BBC Pie is about.",
        text: `Interracial scenes that end the way the name promises, all filmed in 4K. ${n}+ scenes and growing, with new releases added regularly.`,
      },
      {
        lead: "Why join this week.",
        text: "The Black Friday price is the lowest we run. Lock it in now and get every new scene as it drops.",
      },
    ],
  },
  "castingcouch-x.com": {
    brand: "Casting Couch X",
    slug: "castingcouch-x",
    accent: "#ec4899",
    videos: "amateur casting",
    format: "HD",
    titleOffer: "Off",
    intro: ({ discount, price, ends }) =>
      `It's Black Friday at Casting Couch X: ${discount} off a membership, every audition unlocked, just ${price}. The offer ends ${ends}.`,
    body: ({ n }) => [
      {
        lead: "Real first-time auditions.",
        text: `Casting Couch X is the original amateur casting series: new faces (all 18+ and fully verified) sitting down for their first shoot, nerves and all. ${n}+ episodes in HD.`,
      },
      {
        lead: "Get the whole archive.",
        text: "One membership unlocks every episode we've ever made and every new one we release. This is the cheapest it gets all year.",
      },
    ],
  },
  "cum4k.com": {
    brand: "Cum4K",
    slug: "cum4k",
    accent: "#f85079",
    videos: "creampie",
    format: "Ultra HD 4K",
    intro: ({ discount, price, ends }) =>
      `Cum4K's Black Friday sale is on. Get ${discount} off and unlock every creampie scene in Ultra HD 4K for just ${price}. Our lowest price of the year ends ${ends}.`,
    body: ({ n, ends }) => [
      {
        lead: "The creampie specialists.",
        text: `Cum4K has spent years perfecting one kind of finish and filming it in true Ultra HD 4K. ${n}+ scenes with top performers, and new releases added regularly.`,
      },
      {
        lead: "One price, all of it.",
        text: `Your membership unlocks the full archive plus everything we add while you're a member. Grab it now; the price goes back up after ${ends}.`,
      },
    ],
  },
  "exotic4k.com": {
    brand: "Exotic4K",
    slug: "exotic4k",
    accent: "#16a34a",
    videos: "exotic model",
    format: "Ultra HD 4K",
    intro: ({ discount, price, ends }) =>
      `For Black Friday only, Exotic4K is ${discount} off. Join for ${price} and get every scene with our stunning models from around the world, all in Ultra HD 4K. Ends ${ends}.`,
    body: ({ n }) => [
      {
        lead: "Models from everywhere.",
        text: `Exotic4K features gorgeous performers from around the world, shot in true 4K so every scene looks its best. ${n}+ scenes and counting.`,
      },
      {
        lead: "Why this week.",
        text: "Black Friday is the only time we drop the price this low. Join now and keep watching every new release.",
      },
    ],
  },
  "facials4k.com": {
    brand: "Facials4K",
    slug: "facials4k",
    accent: "#22c55e",
    videos: "facial cumshot",
    format: "Ultra HD 4K",
    intro: ({ discount, price, ends }) =>
      `The Facials4K Black Friday deal is here: ${discount} off a membership and the entire library for just ${price}. It's our best price of the year, and it ends ${ends}.`,
    body: ({ n }) => [
      {
        lead: "Built around the finish.",
        text: `Facials4K is all about the big finale, captured up close in Ultra HD 4K. ${n}+ scenes featuring the biggest names in the business.`,
      },
      {
        lead: "Everything unlocked.",
        text: "Full library, every new update, any device. Lock in the Black Friday price before it's gone.",
      },
    ],
  },
  "girlcum.com": {
    brand: "GirlCum",
    slug: "girlcum",
    accent: "#db5186",
    videos: "female orgasm",
    format: "4K",
    intro: ({ discount, price, ends }) =>
      `GirlCum's Black Friday sale is live: ${discount} off a membership and every scene in 4K for just ${price}. Once ${ends} is over, so is the deal.`,
    body: ({ n }) => [
      {
        lead: "Real pleasure, front and center.",
        text: `GirlCum focuses on genuine female orgasms: no faking, no rushing, just performers who are into it, filmed in 4K. ${n}+ scenes and growing.`,
      },
      {
        lead: "The best time to join.",
        text: "This is the lowest price we offer all year. Join now and get every new scene as it's released.",
      },
    ],
  },
  "holed.com": {
    brand: "Holed",
    slug: "holed",
    accent: "#db4490",
    videos: "anal",
    format: "Full HD and 4K",
    intro: ({ discount, price, ends }) =>
      `Holed is ${discount} off for Black Friday. Join for ${price} and get the full library of anal scenes in Full HD and 4K. The sale ends ${ends}.`,
    body: ({ n }) => [
      {
        lead: "A Holed classic.",
        text: `Holed has been one of the most recognizable names in anal for years, with ${n}+ scenes in Full HD and newer releases in 4K. Big names, high production, no filler.`,
      },
      {
        lead: "Lowest price of the year.",
        text: "We only go this low once a year. Join this week and get every new release while you're a member.",
      },
    ],
  },
  "lubed.com": {
    brand: "Lubed",
    slug: "lubed",
    accent: "#00d3ff",
    videos: "oiled-up",
    format: "Full HD and 4K",
    intro: ({ discount, price, ends }) =>
      `Lubed's Black Friday deal is here: ${discount} off a membership, the whole slippery library for just ${price}. It ends ${ends}.`,
    body: ({ n }) => [
      {
        lead: "Slick from start to finish.",
        text: `Every Lubed scene is wet, oiled-up and glistening, filmed in Full HD and 4K. ${n}+ scenes and new ones added regularly.`,
      },
      {
        lead: "Why join now.",
        text: "Black Friday is the cheapest it gets. Lock in the price today and keep every new release coming.",
      },
    ],
  },
  "pornplus.com": {
    brand: "PornPlus",
    slug: "pornplus",
    accent: "#ff2fbf",
    videos: "hardcore",
    format: "4K",
    titleOffer: ({ sites }) => `Off ${sites} Sites`,
    intro: ({ discount, price, ends, sites }) =>
      `This is the biggest deal in our network. For Black Friday, PornPlus is ${discount} off: one membership, ${sites} sites, every scene in 4K, for just ${price}. Ends ${ends}.`,
    body: ({ n, sites, siteNames }) => [
      {
        lead: `${sites} sites, one login.`,
        text: `PornPlus brings together our whole network${siteNames ? `, including ${siteNames} and more,` : ""} in one membership. That's ${n}+ scenes across every niche we make.`,
      },
      {
        lead: "Best value all year.",
        text: "If you're already a fan of one of our sites, this is the cheapest way to get all of them. The Black Friday price won't come around again until next November.",
      },
    ],
  },
  "pornpros.com": {
    brand: "PornPros",
    slug: "pornpros",
    accent: "#dc2626",
    videos: "hardcore",
    format: "Full HD",
    intro: ({ discount, price, ends }) =>
      `PornPros is ${discount} off for Black Friday. Get the full library of hardcore scenes in Full HD for just ${price}, our lowest price of the year. Ends ${ends}.`,
    body: ({ n, ends }) => [
      {
        lead: "The original.",
        text: `PornPros is where our network started, with ${n}+ hardcore scenes featuring the biggest names in porn, all in Full HD.`,
      },
      {
        lead: "Get it all for less.",
        text: `Your membership unlocks every scene and every new release. Join before ${ends} to keep the Black Friday price.`,
      },
    ],
  },
  "puremature.com": {
    brand: "PureMature",
    slug: "puremature",
    accent: "#c56df8",
    videos: "MILF",
    format: "Full HD",
    intro: ({ discount, price, ends }) =>
      `PureMature's Black Friday sale is here: ${discount} off a membership and every scene in Full HD for just ${price}. The price goes back up after ${ends}.`,
    body: ({ n }) => [
      {
        lead: "Experience shows.",
        text: `PureMature features confident, gorgeous MILFs who know exactly what they want, in beautifully shot Full HD scenes. ${n}+ scenes in the library and more added regularly.`,
      },
      {
        lead: "Why join now.",
        text: "This is our lowest price of the year. Join this week and keep the full library and every new release.",
      },
    ],
  },
  "spyfam.com": {
    brand: "SpyFam",
    slug: "spyfam",
    accent: "#ff0000",
    videos: "step family",
    format: "4K",
    intro: ({ discount, price, ends }) =>
      `SpyFam is ${discount} off this Black Friday. Join for ${price} and watch every scene in 4K. The deal ends ${ends}.`,
    body: ({ n, ends }) => [
      {
        lead: "Step-family fantasy, done in 4K.",
        text: `SpyFam's scripted scenes play out the classic "caught in the act" step-family storylines, with hidden-camera style shooting and full 4K production. ${n}+ scenes. All performers are adults, 18 or older, and not related; every scene is fictional role-play.`,
      },
      {
        lead: "Lowest price of the year.",
        text: `Join before ${ends} to lock in the Black Friday price and get every new release.`,
      },
    ],
  },
  "strippers4k.com": {
    brand: "Strippers4K",
    slug: "strippers4k",
    accent: "#be185d",
    videos: "stripper",
    format: "Ultra HD 4K",
    titleOffer: "Off",
    intro: ({ discount, price, ends }) =>
      `Strippers4K's Black Friday sale is live. Get ${discount} off and every scene in Ultra HD 4K for just ${price}. Once ${ends} ends, so does the price.`,
    body: ({ n }) => [
      {
        lead: "The VIP room, in 4K.",
        text: `Strippers4K takes you past the stage and into the private room, with stunning dancers and true Ultra HD 4K production. ${n}+ scenes and growing.`,
      },
      {
        lead: "Your best chance all year.",
        text: "Black Friday is the only time we cut the price this far. Join now and get every new scene as it drops.",
      },
    ],
  },
  "tiny4k.com": {
    brand: "Tiny4K",
    slug: "tiny4k",
    accent: "#18d3ff",
    // The doc's "petite girl videos", minus the word payment processors and
    // Google's policy reviewers flag in this niche.
    videos: "petite",
    format: "Ultra HD 4K",
    intro: ({ discount, price, ends }) =>
      `Tiny4K is ${discount} off for Black Friday. Join for ${price} and get every scene in Ultra HD 4K, our lowest price of the year. It ends ${ends}.`,
    body: ({ n }) => [
      {
        lead: "Petite performers, big production.",
        text: `Tiny4K features petite adult performers, all 18 or older and fully verified, in scenes shot in true Ultra HD 4K. ${n}+ scenes with new releases added regularly.`,
      },
      {
        lead: "Get the whole library.",
        text: "One membership unlocks everything we've made and everything we release next. Lock in the Black Friday price before it's gone.",
      },
    ],
  },
  "wetvr.com": {
    brand: "WetVR",
    slug: "wetvr",
    accent: "#93c5fd",
    videos: "virtual reality",
    format: "4K VR",
    titleOffer: "Off VR Memberships",
    intro: ({ discount, price, ends }) =>
      `WetVR's Black Friday sale is on: ${discount} off a membership and every VR scene in 4K for just ${price}. Grab your headset; the deal ends ${ends}.`,
    body: ({ n, ends }) => [
      {
        lead: "Be in the room.",
        text: `WetVR puts you right in the scene with immersive 4K VR, made for Quest, Vive, Index and other headsets, and watchable on your phone too. ${n}+ VR scenes and counting.`,
      },
      {
        lead: "Black Friday is the time to start.",
        text: `If you've just got a headset, or are getting one as a gift, this is the cheapest way to fill it. Our lowest price of the year ends ${ends}.`,
      },
    ],
  },
}

const normalizeHost = (host) =>
  String(host ?? "")
    .toLowerCase()
    .replace(/^www\./, "")

// The Black Friday settings for the site served as `host`, or null when that
// site has no Black Friday page.
export const blackFridaySite = (host) =>
  BLACK_FRIDAY_SITES[normalizeHost(host)] ?? null

// The other sites' pages, for the network block.
export const otherBlackFridaySites = (host) =>
  Object.entries(BLACK_FRIDAY_SITES)
    .filter(([siteHost]) => siteHost !== normalizeHost(host))
    .map(([siteHost, site]) => ({
      brand: site.brand,
      logo: `/images/sites/${site.slug}/logo.png`,
      href: `https://${siteHost}/black-friday`,
    }))

// Black or white, whichever reads better on `hex`.
export const textOn = (hex) => {
  const [r, g, b] = [1, 3, 5].map((i) => {
    const c = parseInt(hex.slice(i, i + 2), 16) / 255
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4
  })
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b
  return luminance > 0.179 ? "#000000" : "#ffffff"
}

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1)

const formatCount = (count) =>
  count ? new Intl.NumberFormat("en-US").format(count) : null

const ordinal = (day) => {
  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
          ? "rd"
          : "th"
  return `${day}${suffix}`
}

const DAY = 24 * 60 * 60 * 1000

// "for one week only", "for 12 days only"
const forHowLong = ({ startsAt, endsAt }) => {
  if (!startsAt) return "for a limited time only"
  const days = Math.round((endsAt - startsAt) / DAY)
  return days === 7 ? "for one week only" : `for ${days} days only`
}

// The page's words for the site served as `host`, in the sale's phase
// (`state` from seasonState). `data`:
//   scenes    — the site's scene count
//   sites     — Porn+'s site count
//   siteNames — a few of Porn+'s sites, joined
//   thisYear  — the year it is now, so an ended sale can say "this year's"
// Paragraphs that carry a link are arrays of strings and { text, href }.
export const blackFridayCopy = (host, data) => {
  const site = blackFridaySite(host)
  if (!site) return null

  const { state } = data
  const { brand } = site
  const { discount, salePrice, regularPrice, billingLine } = BLACK_FRIDAY_OFFER
  const joinUrl = `/join?promo=bf${state.year}`
  const ends = saleEndDay(state.endsAt)
  const words = {
    discount,
    price: salePrice,
    ends,
    n: formatCount(data.scenes) ?? "thousands of",
    sites: formatCount(data.sites) ?? "70",
    siteNames: data.siteNames,
  }
  const titleOffer =
    typeof site.titleOffer === "function"
      ? site.titleOffer(words)
      : (site.titleOffer ?? "Off Memberships")

  const live = state.phase === "live"
  const ended = state.phase === "ended"
  // upcoming has dates; unscheduled doesn't yet.
  const starts = state.startsAt ? saleDate(state.startsAt) : null
  const thisYears =
    data.thisYear && data.thisYear !== state.year
      ? `The ${state.year}`
      : "This year's"

  const intro = live
    ? [[site.intro(words)]]
    : ended
      ? [
          [
            `${thisYears} ${brand} Black Friday sale has ended. It's back every November with our lowest price of the year. Until then, you can `,
            { text: `join ${brand} at the regular price`, href: "/join" },
            " and start watching today.",
          ],
        ]
      : [
          [
            starts
              ? `The ${brand} Black Friday sale starts ${starts}, with our lowest price of the year: ${discount} off a membership. It runs through ${saleEndDate(state.endsAt)}. Bookmark this page and come back on the ${ordinal(saleDayOfMonth(state.startsAt))}, or `
              : `The ${brand} Black Friday sale starts this November, with our lowest price of the year: ${discount} off a membership. It runs through Cyber Monday. Bookmark this page and come back when it starts, or `,
            { text: "join now at the regular price", href: joinUrl },
            " and start watching today.",
          ],
        ]

  const startsLine = starts ? `Starts ${starts}` : "Starts this November"

  return {
    brand,
    accent: site.accent,
    onAccent: textOn(site.accent),
    format: site.format,
    joinUrl,
    title: `${brand} Black Friday Sale ${state.year} – ${capitalize(discount)} ${titleOffer} | ${brand}`,
    heading: `${brand} Black Friday Deal ${state.year}`,
    description: `${brand} Black Friday ${state.year}: get ${discount} off a membership and unlimited ${site.videos} videos in ${site.format}. Limited time, ends ${ends}. Join now.`,

    topBar: live
      ? {
          text: `Black Friday: ${discount} off ${brand} — ends`,
          short: `Black Friday: ${discount} off — ends`,
          // The server's words in place of the countdown, so the bar still
          // reads without JavaScript.
          fallback:
            `${ends === "Cyber Monday" ? "Cyber Monday" : saleWeekday(state.endsAt)}, ${tinySaleDate(state.endsAt)}`.toUpperCase(),
          cta: "Get the deal →",
        }
      : ended
        ? null
        : {
            text: starts
              ? `Black Friday sale starts ${saleWeekday(state.startsAt)}, ${tinySaleDate(state.startsAt)} — ${discount} off ${brand}`
              : `Black Friday sale starts this November — ${discount} off ${brand}`,
            short: starts
              ? `Black Friday starts ${tinySaleDate(state.startsAt)} — ${discount} off`
              : `Black Friday this November — ${discount} off`,
          },

    hero: {
      label: `Black Friday ${state.year}`,
      subheading: live
        ? `${capitalize(discount)} off a ${brand} membership. Our lowest price of the year.`
        : ended
          ? `${thisYears} sale has ended. It's back every November.`
          : starts
            ? `Our lowest price of the year starts ${starts}.`
            : "Our lowest price of the year starts this November.",
      button: live
        ? `Get ${discount} off`
        : ended
          ? `Join ${brand}`
          : "Join now at the regular price",
      href: ended ? "/join" : joinUrl,
      note: live ? `Offer ends ${saleEndDate(state.endsAt)}.` : null,
    },

    priceBox: live
      ? {
          label: "Black Friday price",
          price: salePrice,
          period: "/ month",
          regular: regularPrice,
          saving: `Save ${discount}`,
          billing: billingLine,
          deadline: `Offer ends ${saleEndDate(state.endsAt)} at ${saleTime(state.endsAt)}`,
          button: `Get ${discount} off now`,
          href: joinUrl,
          trust: ["No coupon needed", "Discreet billing", "Cancel anytime"],
        }
      : ended
        ? {
            label: `Join ${brand}`,
            price: regularPrice,
            period: "/ month",
            line: "Our Black Friday sale is back every November.",
            button: `Join ${brand}`,
            href: "/join",
          }
        : {
            label: "Black Friday price",
            price: `${capitalize(discount)} off`,
            line: startsLine,
            button: `Join now at the regular price (${regularPrice}/month)`,
            href: joinUrl,
            note: starts
              ? `Or come back on the ${ordinal(saleDayOfMonth(state.startsAt))} for our lowest price of the year.`
              : "Or come back when it starts for our lowest price of the year.",
          },

    intro,

    features: [
      { icon: "film", text: `${words.n}+ full scenes` },
      { icon: "screen", text: site.format },
      { icon: "calendar", text: "New scenes added regularly" },
      { icon: "phone", text: "Watch on any device" },
    ],

    scenes: {
      heading: `Watch the best of ${brand}`,
      button: `See all ${words.n}+ scenes`,
    },

    body: {
      heading: `Why join ${brand} this Black Friday`,
      sections: site.body(words),
    },

    band: live
      ? {
          heading: "Don't miss our lowest price of the year.",
          line: `${capitalize(discount)} off ${brand} ends ${saleEndDate(state.endsAt)}.`,
          button: "Get the deal",
          href: joinUrl,
        }
      : ended
        ? null
        : {
            heading: starts
              ? `Our Black Friday sale starts ${starts}.`
              : "Our Black Friday sale starts this November.",
            line: `${capitalize(discount)} off our regular price, ${forHowLong(state)}.`,
            button: "Join now",
            href: joinUrl,
          },

    faq: [
      {
        q: `When does the ${brand} Black Friday sale start and end?`,
        a: [
          state.startsAt
            ? `The sale starts ${saleDate(state.startsAt)}, ${saleYear(state.startsAt)}, and ends on ${saleEndDate(state.endsAt)}, ${saleYear(state.endsAt)}, at ${saleTime(state.endsAt)}. After that, the price goes back to normal.`
            : ended
              ? `${thisYears} sale has ended. It's back every November, starting the week of Black Friday and running through Cyber Monday.`
              : "It starts the week of Black Friday and runs through Cyber Monday. The exact dates will be on this page as soon as they're set.",
        ],
      },
      {
        q: "Do I need a coupon code?",
        a: [
          "No. The Black Friday price is applied automatically when you join from this page.",
        ],
      },
      {
        q: "Does the price go up after the first month?",
        a: [
          "No. You keep the Black Friday price for as long as you stay a member.",
        ],
      },
      {
        q: "Can I cancel anytime?",
        a: [
          "Yes, at any time, through our billing support site, ",
          { text: "cvvhelp.net", href: "https://cvvhelp.net" },
          ". You keep access until the end of the period you paid for.",
        ],
      },
      {
        q: "Is billing discreet?",
        a: [
          "Yes. Payments are processed securely and show up on your statement under a discreet name.",
        ],
      },
    ],

    network: ended
      ? null
      : {
          heading: "More Black Friday deals from our network",
          line: "Every site in our network is on sale through Cyber Monday.",
          sites: otherBlackFridaySites(host),
        },
  }
}

// "A, B and C"
export const joinNames = (names = []) =>
  names.length > 1
    ? `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`
    : (names[0] ?? "")
